export enum FormMaskConstants {
	PHONE_MASK = <any>[
		"(",
		/[1-9]/,
		/\d/,
		/\d/,
		")",
		" ",
		/\d/,
		/\d/,
		/\d/,
		"-",
		/\d/,
		/\d/,
		/\d/,
		/\d/
	],
	DATE_MASK = <any>[/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/],
	ZIP_MASK = <any>[/\d/, /\d/, /\d/, /\d/, /\d/],
	ACCOUNT_NUMBER_MASK = <any>[
		/\d/,
		/\d/,
		/\d/,
		/\d/,
		/\d/,
		/\d/,
		/\d/,
		/\d/,
		/\d/,
		/\d/,
		/\d/,
		/\d/,
		/\d/,
		/\d/,
		/\d/,
		/\d/
	],
	RESET_CODE_MASK = <any>[
		/[0-9a-zA-Z]/,
		/[0-9a-zA-Z]/,
		/[0-9a-zA-Z]/,
		/[0-9a-zA-Z]/,
		/[0-9a-zA-Z]/,
		/[0-9a-zA-Z]/
	],
	LAST_4_SSN_MASK = <any>[/\d/, /\d/, /\d/, /\d/],
	LAST_4_CC_MASK = <any>[/\d/, /\d/, /\d/, /\d/],
	PIN_CODE_MASK = <any>[/\d/, /\d/, /\d/, /\d/],
	ONETIME_CODE_MASK = <any>[/\d/, /\d/, /\d/, /\d/, /\d/, /\d/]
}
